import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { validateEnvironment } from './config/environment';
import { logger } from './utils/logger';
import App from './App';
import './index.css';

// Log app initialization
logger.info('Application initializing', {
  environment: import.meta.env.MODE,
  buildTime: __BUILD_TIME__
});

// Validate environment variables before app starts
validateEnvironment();

// Log successful environment validation
logger.info('Environment validation successful');

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);